export default __webpack_public_path__ + "static/media/_DSC0811.30b177d9.JPG";